"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Standard Price Book or not で結構分岐があるので作成。
 */
var value_checker_1 = __importDefault(require("../validation/value_checker"));
var SalesForcePriceBookUtils = /** @class */ (function () {
    function SalesForcePriceBookUtils() {
    }
    SalesForcePriceBookUtils.isStandardPriceBook = function (priceBookId) {
        if (value_checker_1.default.isBlank(priceBookId)) {
            return false;
        }
        return priceBookId.trim() === SalesForcePriceBookUtils.STANDARD_PRICE_BOOK_ID;
    };
    SalesForcePriceBookUtils.isOralCareStandardPriceBookPriceBook = function (priceBookId) {
        if (value_checker_1.default.isBlank(priceBookId)) {
            return false;
        }
        return priceBookId.trim() === SalesForcePriceBookUtils.ORAL_CARE_FREE_PRICE_BOOK_ID;
    };
    SalesForcePriceBookUtils.isNotStandardPriceBook = function (priceBookId) {
        return !SalesForcePriceBookUtils.isStandardPriceBook(priceBookId);
    };
    /**
     * 特別対応かどうか。以下のいずれかの条件を満たす場合、特別対応と判定。
     * - StandardPriceBook以外。
     * - 無料期間有り。
     * @param priceBookId
     * @param freeFlg
     */
    SalesForcePriceBookUtils.isAbnormal = function (priceBookId, freeFlg) {
        return SalesForcePriceBookUtils.isNotStandardPriceBook(priceBookId) ||
            SalesForcePriceBookUtils.hasFree(freeFlg);
    };
    /**
     * 無料期間を持っているかどうか。
     * @param freeFlg
     */
    SalesForcePriceBookUtils.hasFree = function (freeFlg) {
        return freeFlg && freeFlg.length;
    };
    SalesForcePriceBookUtils.getKobetuProductData = function (priceBookEntry, capacity, period) {
        if (value_checker_1.default.isBlank(capacity) || value_checker_1.default.isBlank(period)) {
            return {
                price: ''
            };
        }
        console.log(priceBookEntry);
        var productDataList = priceBookEntry.filter(function (entry) {
            console.log("Family: " + entry['family'] + " capacity: " + entry['capacity'] + " period: " + entry['period']);
            return entry['family'] === SalesForcePriceBookUtils.FAMILY_KOBETU &&
                entry['capacity'] === capacity &&
                entry['period'] === period;
        });
        if (productDataList.length) {
            return productDataList[0];
        }
        return {
            price: ''
        };
    };
    SalesForcePriceBookUtils.getOralCareProductData = function (priceBookEntry, period) {
        if (value_checker_1.default.isBlank(period)) {
            return {
                price: ''
            };
        }
        var productDataList = priceBookEntry.filter(function (entry) {
            return entry['family'] === SalesForcePriceBookUtils.FAMILY_ORAL_CARE &&
                entry['period'] === period;
        });
        if (productDataList.length) {
            return productDataList[0];
        }
        return {
            price: ''
        };
    };
    SalesForcePriceBookUtils.isSelectableProduct = function (priceBookId) {
        if (value_checker_1.default.isBlank(priceBookId)) {
            return true;
        }
        return SalesForcePriceBookUtils.isStandardPriceBook(priceBookId);
    };
    Object.defineProperty(SalesForcePriceBookUtils, "STANDARD_PRICE_BOOK_ID", {
        get: function () {
            return '01s0o000009gyimAAA';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForcePriceBookUtils, "ORAL_CARE_FREE_PRICE_BOOK_ID", {
        get: function () {
            return '01s2j0000008airAAA';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForcePriceBookUtils, "FAMILY_KOBETU", {
        get: function () {
            return '個別機能訓練加算';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForcePriceBookUtils, "FAMILY_ORAL_CARE", {
        get: function () {
            return '口腔機能向上加算';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForcePriceBookUtils, "FAMILY_BASIC", {
        get: function () {
            return 'Rehab Cloud Basic';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForcePriceBookUtils, "FAMILY_STANDARD", {
        get: function () {
            return 'Rehab Cloud Standard';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForcePriceBookUtils, "FAMILY_ENTRY", {
        get: function () {
            return 'Rehab Cloud Entry';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForcePriceBookUtils, "FAMILY_MEDIUM", {
        get: function () {
            return 'Rehab Cloud Medium';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForcePriceBookUtils, "FAMILY_PROFESSIONAL", {
        get: function () {
            return 'Rehab Cloud Pro';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForcePriceBookUtils, "FAMILY_UPGRADE_TO_STANDARD", {
        get: function () {
            return 'Rehab Cloud アップグレード';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForcePriceBookUtils, "FAMILY_UPGRADE", {
        get: function () {
            return 'Rehab Cloud アップグレード';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForcePriceBookUtils, "FAMILY_ADDITIONAL_TABLET", {
        get: function () {
            return 'Rehab Cloud タブレット';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesForcePriceBookUtils, "FAMILY_MOTION_AI", {
        get: function () {
            return 'Rehab Cloud モーションAI';
        },
        enumerable: true,
        configurable: true
    });
    return SalesForcePriceBookUtils;
}());
exports.default = SalesForcePriceBookUtils;



//////////////////
// WEBPACK FOOTER
// ./common/src/utils/sales_force/price_book_utils.ts
// module id = rTjK
// module chunks = 1